import { render } from "./LayoutDictionary.vue?vue&type=template&id=168f1704&scoped=true"
import script from "./LayoutDictionary.vue?vue&type=script&lang=js"
export * from "./LayoutDictionary.vue?vue&type=script&lang=js"

import "./LayoutDictionary.vue?vue&type=style&index=0&id=168f1704&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168f1704"]])

export default __exports__